import React, { useEffect, useState } from "react";
import { MessageType, Product } from "../constants";
import "../modal.css";
import logo from '../static/images/sbilife-logo.png'
import { numDifferentiation } from "../utils";
import HealthPlanComparisionPopup from "./Health/PlanComparisionPopup";
import TravelPlanComparisionPopup from "./Travel/PlanComparisionPopup";
export default function PlanComparisionPopup({ message, closeComparision, productId }) {
    const [openModal, setOpenModal] = useState("")
    const [selectedPlan, setSelectedPlan] = useState("")
    const [planList, setPlanList] = useState([])
    const [content, setMessageContent] = useState("")
    // const content = JSON.parse(message.content)

    useEffect(() => {
        console.log(message)
        setOpenModal("open")
        if (message && message.content) {
            setMessageContent(JSON.parse(message.content))
        }
    }, [message])


    return (
        <>
            {productId === Product.Health ?
                <HealthPlanComparisionPopup
                    content={content}
                    closeComparision={closeComparision}
                    message={message}
                    openModal={openModal}
                />
                : null}
            {productId === Product.Travel ?
                <TravelPlanComparisionPopup
                    content={content}
                    closeComparision={closeComparision}
                    message={message}
                    openModal={openModal}
                />
                : null}
        </>
    );
}
